// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AddToBasketRequestModel from '../../model/add-to-basket-request-model';
import AddToBasketRequestDTO from '../dto/add-to-basket-request-dto';
import dtoSchema from '../schemas/add-to-basket-request-schema';

export default abstract class AddToBasketRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AddToBasketRequestDTO>) {
    super();
    if (data) {
      this.articleId = data.articleId;
      this.quantity = data.quantity ?? undefined;
      this.userId = data.userId;
      this.publicBasketId = data.publicBasketId;
    }
  }
  /**
  * @type {int64}
  */
  articleId?: number;
  /**
  * @type {int32}
  */
  quantity?: number;
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {uuid}
  */
  publicBasketId?: string;

  static toModel(dto: DeepPartial<AddToBasketRequestDTO>): AddToBasketRequestModel;
  static toModel(dto: DeepPartial<AddToBasketRequestDTO> | undefined | null): AddToBasketRequestModel | undefined;
  static toModel(dto: DeepPartial<AddToBasketRequestDTO> | undefined | null): AddToBasketRequestModel | undefined {
    return dto ? new AddToBasketRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AddToBasketRequestModel> | AddToBasketRequestModel): AddToBasketRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      articleId: unwrapped.articleId,
      quantity: unwrapped.quantity,
      userId: unwrapped.userId,
      publicBasketId: unwrapped.publicBasketId,
    } as AddToBasketRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AddToBasketRequestModel, can not map to AddToBasketRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
